/* ==========================================================================
   PRODUCT PAGE — genres from the collector (Rue, 2026-09-19: "records must be
   mapped to their genre details collected, everywhere on the website").

   The page still renders Discogs' genre/style fields server-side; this file
   replaces every place they surface with the record's Dig / Catalog genres and
   tags, read from the Catalog's own data (assets/pn-catalog-data.js, the
   collector's PARANOISE_GENRES v8 truth), and links each to that genre or tag
   on the Catalog (/collections/all#/<genre>[/<tag>]):
     - the crumbs            (After Hours .pnah-crumbs, Sticky .pnsn-crumbs)
     - the genre line         (After Hours .pnah-genres, Sticky .pnsn-chips)
     - the sheet's Genre / Style / Subgenre rows (both designs)
   A record the collector has not sorted yet shows "Not yet sorted" (the
   Catalog's own name for it) instead of Discogs' words.

   It also defines window.PNSimilar BEFORE pn-sticky.js / pn-afterhours.js
   (both only define theirs `if (!window.PNSimilar)`), so the similar-records
   panels rank by shared collector tags instead of Discogs styles. Same
   interface: load(n) -> Promise<[rec]>, rec = {handle, artist, title, name,
   label, price, bpm, style, genre, img, available, created, href}. No tag in
   common -> no card (Rue: an empty shelf beats a wrong one).
   ========================================================================== */
(function () {
  'use strict';
  if (window.PNDigProduct) return; window.PNDigProduct = true;
  var CAT = '/collections/all#/';
  var me = document.currentScript;
  var DATA_URL = me && me.getAttribute('data-catalog');

  var slug = function (s) { return String(s).toLowerCase().replace(/″/g, 'in').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function handle() { if (window.PN_DIG_TEST_HANDLE) return window.PN_DIG_TEST_HANDLE; var s = location.pathname.split('/').filter(Boolean), i = s.indexOf('products'); return i >= 0 ? decodeURIComponent(s[i + 1] || '') : ''; }

  /* the Catalog data, loaded once, async */
  var ready = new Promise(function (res) {
    if (window.PN_CATALOG) return res(window.PN_CATALOG);
    if (!DATA_URL) return res(null);
    var s = document.createElement('script'); s.src = DATA_URL; s.async = true;
    s.onload = function () { res(window.PN_CATALOG || null); }; s.onerror = function () { res(null); };
    document.head.appendChild(s);
  });
  function lookup(D) {
    var h = handle(), i;
    for (i = 0; i < D.recs.length; i++) if (D.recs[i].h === h) return D.recs[i];
    return null;
  }
  /* genre first, then the tags that belong to that genre, then any others */
  function parts(D, r) {
    var gs = r.m.slice(), g0 = gs[0];
    var tags = r.g.slice().sort(function (a, b) {
      var ia = D.tagParents[a].indexOf(g0) >= 0 ? 0 : 1, ib = D.tagParents[b].indexOf(g0) >= 0 ? 0 : 1; return ia - ib;
    });
    function tagHome(t) { return D.tagParents[t].indexOf(g0) >= 0 ? g0 : D.tagParents[t][0]; }
    /* a tag spelled like one of the record's genres ("Techno", "House") is
       already said by the genre, so it is not repeated in the line */
    var gnames = gs.map(function (g) { return D.genres[g].toLowerCase(); });
    tags = tags.filter(function (t) { return gnames.indexOf(D.tags[t].toLowerCase()) < 0; });
    return {
      genres: gs.map(function (g) { return { n: D.genres[g], href: CAT + slug(D.genres[g]) }; }),
      tags: tags.map(function (t) { return { n: D.tags[t], href: CAT + slug(D.genres[tagHome(t)]) + '/' + slug(D.tags[t]) }; })
    };
  }
  var A = function (x) { return '<a href="' + esc(x.href) + '">' + esc(x.n) + '</a>'; };

  function rewrite(D) {
    var r = D ? lookup(D) : null;
    var P = r ? parts(D, r) : null;
    var unsorted = { n: 'Not yet sorted', href: CAT.replace(/#\/$/, '#/not-yet-sorted') };
    /* crumbs: Catalog / genre / tag */
    document.querySelectorAll('.pnah-crumbs, .pnsn-crumbs').forEach(function (nav) {
      var first = nav.querySelector('a'); if (!first) return;
      var sticky = nav.classList.contains('pnsn-crumbs');
      var sep = sticky ? '<span>/</span>' : ' / ';
      var bits = P ? [P.genres[0]].concat(P.tags.slice(0, 1)).filter(Boolean) : [unsorted];
      nav.innerHTML = first.outerHTML + bits.map(function (b) { return sep + A(b); }).join('');
    });
    /* After Hours genre line */
    document.querySelectorAll('.pnah-genres').forEach(function (el) {
      el.innerHTML = P ? P.genres.concat(P.tags).map(A).join(' · ') : A(unsorted);
    });
    /* Sticky Note chips */
    document.querySelectorAll('.pnsn-chips').forEach(function (el) {
      var all = P ? P.genres.concat(P.tags) : [unsorted];
      el.innerHTML = all.map(function (x) { return '<a class="pnsn-chip" href="' + esc(x.href) + '">' + esc(x.n) + '</a>'; }).join('');
    });
    /* sheet rows (Sticky cells and After Hours rows): Genre / Style / Subgenre */
    /* Rue, 2 Oct 2026: on the record sheet Genre and Subgenre are plain words written side by side, separated by
       commas - not links, and not one line per word. They used to be links joined by ", ", and the After Hours
       sheet stacks every child of a value (flex column), so each link and each comma landed on its own line;
       records the catalogue does not know kept the Liquid's plain text, hence the two looks. ONE span now carries
       the whole list in both panels. */
    function setRow(k, v) {
      var key = (k.textContent || '').trim().toLowerCase(), words;
      if (key === 'genre') words = P ? P.genres.map(function (x) { return x.n; }) : null;
      else if (key === 'style' || key === 'subgenre' || key === 'styles') words = P ? P.tags.map(function (x) { return x.n; }) : null;
      else return;
      if (!words) {                       /* not in the catalogue: keep the page's own words, minus the links */
        var bits = v.querySelectorAll('a, span');
        words = bits.length ? Array.prototype.map.call(bits, function (b) { return (b.textContent || '').trim(); })
                            : String(v.textContent || '').split(',').map(function (w) { return w.trim(); });
        words = words.filter(function (w) { return w && w !== ',' && w !== '—'; });
      }
      v.innerHTML = '<span style="white-space:normal">' + (words.length ? esc(words.join(', ')) : '—') + '</span>';
      v.setAttribute('data-pn-dig', '1');
    }
    document.querySelectorAll('.pnsn-cell').forEach(function (c) { var k = c.querySelector('.pnsn-cell-k'), v = c.querySelector('.pnsn-cell-v'); if (k && v) setRow(k, v); });
    document.querySelectorAll('.pnah-row').forEach(function (c) { var k = c.querySelector('.pnah-row-k'), v = c.querySelector('.pnah-row-v'); if (k && v) setRow(k, v); });
  }

  /* similar records, ranked by the collector's tags */
  var cache = null, pending = null;
  function money(p) { return p == null ? '' : '$' + (p % 1 ? p.toFixed(2) : p); }
  function img(D, i) { if (!i) return ''; var u = /^https?:/.test(i) ? i : D.imgPrefix + i; return u + (u.indexOf('?') > 0 ? '&' : '?') + 'width=168'; }
  function load(want) {
    want = want || 10;
    if (cache) return Promise.resolve(cache);
    if (pending) return pending;
    pending = ready.then(function (D) {
      var out = [], r = D && lookup(D);
      if (r && r.g.length) {
        var mineT = {}, mineG = {};
        r.g.forEach(function (t) { mineT[t] = 1; }); r.m.forEach(function (g) { mineG[g] = 1; });
        D.recs.forEach(function (c) {
          if (!c.s || c.h === r.h) return;
          var sc = 0; c.g.forEach(function (t) { if (mineT[t]) sc++; });
          if (!sc) return;
          c.m.forEach(function (g) { if (mineG[g]) sc += 0.5; });
          out.push({ c: c, sc: sc });
        });
        out.sort(function (a, b) { return b.sc - a.sc || (a.c.h < b.c.h ? -1 : 1); });
      }
      cache = out.slice(0, want).map(function (o) {
        var c = o.c;
        return { handle: c.h, artist: c.a || '', title: c.t || '', name: (c.a ? c.a + ' - ' : '') + (c.t || ''),
          label: c.l || '', price: money(c.p), bpm: c.b || '', style: c.g.map(function (t) { return D.tags[t]; }).join(', '),
          genre: c.m.map(function (g) { return D.genres[g]; }).join(', '), img: img(D, c.i), available: true, created: '',
          href: '/products/' + c.h, _score: o.sc };
      });
      pending = null;
      return cache;
    });
    return pending;
  }
  window.PNSimilar = { load: load, tags: function () { return { styles: [], genre: '' }; } };

  function done() { document.documentElement.classList.add('pn-dig-done'); }
  setTimeout(done, 4000);
  function go() { ready.then(function (D) { try { rewrite(D); } finally { done(); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
